'use client'

import { useEffect } from 'react'

interface PageData {
  page_section?: string
  page_name?: string
  page_type?: string
  page_id?: string
  [key: string]: any
}


const getUserAgent = () =>
  typeof window !== 'undefined' ? window.navigator.userAgent : ''

const isAppWebview = () => getUserAgent().includes('awz-owner-wv')

/**
 * Hook to update TMS data layer with page-specific information for webview environments.
 */
export const useTmsWebviewPageDataTracking = (pageData: PageData) => {
  // Set utag_data before any render
  if (isAppWebview() && typeof window !== 'undefined' && (window as any).utag_data) {
    (window as any).utag_data = {
      ...(window as any).utag_data,
      ...pageData
    }
  }

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (isAppWebview() && typeof window !== 'undefined' && (window as any).utag_data) {
        const keysToReset = Object.keys(pageData)
        keysToReset.forEach(key => {
          (window as any).utag_data[key] = ''
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}